"use client";

import { c as _c } from "react/compiler-runtime";
import { BusRequestModalCard } from "@/app/[lng]/(mainPages)/buspartner/_components/busrequest-modal-card";
import { useTranslation } from "@/app/i18n/client";
import { Modal } from "@/components/Util/Modal";
import { BusRequest, RequestType } from "@/types/busrequest";
import { UserWithCompany } from "@/types/user";
import { Suspense, useMemo, useState } from "react";
import { BusRequestMap } from "./busrequest-map";
import { BusRequestTable } from "./busrequest-table";
import { Skeleton } from "@/components/ui/skeleton";
import { api } from "@/utils/trpc/react";
import { LoginForm } from "@/app/[lng]/(user-action)/login/login-form";
export function BusrequestMapAndModal(t0) {
  const $ = _c(41);
  const {
    user,
    mapClassName
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [requestsToShow, setRequestsToShow] = useState(t1);
  const [open, setOpen] = useState(false);
  const [openLogin, setOpenLogin] = useState(false);
  const [requests, t2] = api.busrequest.GetRelevantBusrequests.useSuspenseQuery();
  const {
    isError
  } = t2;
  let t3;
  if ($[1] !== requests) {
    t3 = requests ?? [];
    $[1] = requests;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== requestsToShow || $[4] !== t3) {
    let t5;
    if ($[6] !== requestsToShow) {
      t5 = r => requestsToShow.find(f => f === r.id);
      $[6] = requestsToShow;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    t4 = t3.filter(t5);
    $[3] = requestsToShow;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const matchingRequests = t4;
  const {
    t
  } = useTranslation();
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = function openWithRequests(ids) {
      setRequestsToShow(ids);
      setOpen(true);
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const openWithRequests = t5;
  if (isError) {
    let t6;
    if ($[9] !== t) {
      t6 = t("ERRORLOADING");
      $[9] = t;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    let t7;
    if ($[11] !== t6) {
      t7 = <div>{t6}</div>;
      $[11] = t6;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    return t7;
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex h-[50vh] items-center justify-center"><Skeleton className="h-10 w-40 bg-matchbus/10" /></div>;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== mapClassName) {
    t7 = <Suspense fallback={t6}><BusRequestMap openModal={openWithRequests} className={mapClassName} /></Suspense>;
    $[14] = mapClassName;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <BusRequestTable openModal={openWithRequests} />;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== matchingRequests || $[18] !== requestsToShow.length || $[19] !== t) {
    t9 = requestsToShow.length > 1 ? t("MODAL.TITLE.REQUESTSLIST") : matchingRequests[0] ? t(`MODAL.TITLE.${matchingRequests[0].category.toUpperCase() as Uppercase<RequestType>}.TEXT`) : "";
    $[17] = matchingRequests;
    $[18] = requestsToShow.length;
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setOpen(false);
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== matchingRequests || $[23] !== requestsToShow || $[24] !== user?.user) {
    t11 = requestsToShow && matchingRequests ? <div>{matchingRequests.map(request => <BusRequestModalCard request={request} key={"marker" + request.id} user={user?.user} openLogin={setOpenLogin} />)}</div> : <div>Request could not be loaded</div>;
    $[22] = matchingRequests;
    $[23] = requestsToShow;
    $[24] = user?.user;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== open || $[27] !== t11 || $[28] !== t9) {
    t12 = <Modal header={t9} modalDidClose={t10} open={open} className="box-border max-w-6xl">{t11}</Modal>;
    $[26] = open;
    $[27] = t11;
    $[28] = t9;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t) {
    t13 = t("META.LOGIN.TITLE");
    $[30] = t;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => setOpenLogin(false);
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div><LoginForm closeModal={() => setOpenLogin(false)} /></div>;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== openLogin || $[35] !== t13) {
    t16 = <Modal header={t13} modalDidClose={t14} open={openLogin} disableOverflow={true} className="box-border max-w-96">{t15}</Modal>;
    $[34] = openLogin;
    $[35] = t13;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t12 || $[38] !== t16 || $[39] !== t7) {
    t17 = <>{t7}{t8}{t12}{t16}</>;
    $[37] = t12;
    $[38] = t16;
    $[39] = t7;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  return t17;
}